const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;:&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[/-a-z\\d_]*)?$", // hash
    "i",
); // fragment locator

export function isURL(str) {
    if (!str) return false;
    return !!pattern.test(str);
}
